/** Where the task button remembers how far a user got with a task.
 *
 * The status is cached per task *and* per surface, because the same task can be
 * rendered standalone or inside a collection.
 */
export const taskStatusStorageKey = (taskId: string, collectionId?: string) =>
  `taskStatus-${taskId}-${collectionId || "default"}`;

/** Forget a task's cached progress on every surface it may be shown on.
 *
 * Used when a server-side check says the task is not done after all: without
 * this the button stays on its second step, which for an X follow task means
 * the profile link can never be opened again.
 */
export function clearTaskStatus(taskId: string): void {
  const prefix = `taskStatus-${taskId}-`;
  try {
    const staleKeys: string[] = [];
    for (let index = 0; index < localStorage.length; index += 1) {
      const key = localStorage.key(index);
      if (key?.startsWith(prefix)) staleKeys.push(key);
    }
    staleKeys.forEach((key) => localStorage.removeItem(key));
  } catch {
    // A blocked or full localStorage must not break the deep-link handler.
  }
}
